import { ESSNVerificationStatus, schemes, worker_types } from "@zeal/common";
import { z } from "zod";

export const submitWorkerPaycardSocialSecurityCardVerificationSchema = z.object(
  {
    companyID: schemes.companyID(),
    workerID: schemes.mongoObjectId(),
    workerType: z.nativeEnum(worker_types),
    profileInformation: z.object({
      firstName: schemes.formattedName().optional(),
      middleName: z.string().optional(),
      lastName: schemes.formattedName().optional(),
      dob: schemes.dob().optional(),
      ssn: schemes.ssn().optional(),
      ssnAgain: schemes.ssn().optional(),
      address: z.string().optional(),
      addressLine2: z.string().optional(),
      city: z.string().optional(),
      state: z.string().optional(),
      zip: z.string().optional(),
    }),
    personaInquiryId: z.string(),
    forcedResult: z
      .enum([ESSNVerificationStatus.approved, ESSNVerificationStatus.declined])
      .optional(),
  }
);

export type TSubmitWorkerPaycardSocialSecurityCardVerification = z.infer<
  typeof submitWorkerPaycardSocialSecurityCardVerificationSchema
>;
